import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPaymentStatus } from '../api/payment';
import { Box, Typography, CircularProgress } from '@mui/material';

const PaymentStatusPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get(
      'session_id'
    );
    console.log('sessionId:', sessionId);

    if (sessionId) {
      fetchPaymentStatus(sessionId)
        .then((data) => {
          console.log(
            'payment status from API:',
            data.payment_status,
            'price_id:',
            data.price_id
          );
          console.dir(data, { depth: null });

          if (data.payment_status !== 'paid') {
            navigate(
              `/payment-failure?session_id=${sessionId}&company_id=${
                data.company_id || ''
              }&price_id=${data.price_id || ''}&mode=${data.mode || ''}`
            );
          } else {
            navigate(`/complete?session_id=${sessionId}`, {
              state: { status: 'payment' },
            });
          }
        })
        .catch((err) => {
          console.error('fetch error:', err);
          navigate('/payment-failure');
        });
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <CircularProgress size={60} sx={{ mb: 3 }} />
      <Typography variant="h5">決済処理中です</Typography>
      <Typography variant="body1" color="text.secondary">
        少々お待ちください...
      </Typography>
    </Box>
  );
};

export default PaymentStatusPage;
